'use client';
import React, { useEffect, useState, useContext } from 'react';
import { Button } from '../components';
import { SpinnerBox } from './spinner-box';
import { NAMESPACE, useLang } from '@/hooks/use-lang';
import { useCartStore } from '@/app/cart/cart-store';
import { useAppStore } from '@/store/app-store';
import { usePriceStore } from '@/store/price-store';
import { Product } from '@/types/cart';
import clsx from 'clsx';
import { useDownloadQuotation } from '@/hooks/pdf.hook';
import { useGetQuotationData } from '@/hooks/cart.hook';

interface IProps {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  subTotal?: string;
  vat?: string;
  totalPrice?: string;
  products?: Product[];
}
export const DownloadQuotation = ({ children, className, disabled, subTotal, vat, totalPrice, products }: IProps) => {
  const { t, lang } = useLang(NAMESPACE.downloadQuotation);
  const { mutateAsync, isLoading } = useDownloadQuotation();
  const { mutateAsync: asyncQuotation } = useGetQuotationData();
  const { isAnonymous, shipToList = [] } = useAppStore();
  const { address, availabilityByCatalogNumber } = useCartStore();
  const [selectedShipTo, setSelectedShipTo] = useState({} as any);
  const { productPrice, promotionInfo, fbpSkuInfo } = usePriceStore();

  let data = {
    isAnonymous,
    subTotal,
    vat,
    totalPrice,
    products,
    productPrice,
    availability: availabilityByCatalogNumber,
    promotionInfo,
  };
  const onExport = async () => {
    if (!isAnonymous && selectedShipTo?.addressKey) {
      const addressData = await asyncQuotation(selectedShipTo?.addressKey);
      if (!addressData?.data) return;
      if (promotionInfo && promotionInfo?.promoType === 'FBP') {
        data = { ...{ addressData: addressData.data }, ...data, ...{ fbpSkuInfo: fbpSkuInfo } };
      } else {
        data = { ...{ addressData: addressData.data }, ...data };
      }
    } else if (promotionInfo && promotionInfo?.promoType === 'FBP') {
      data = { ...data, ...{ fbpSkuInfo: fbpSkuInfo } };
    }
    const pdfUrl = await mutateAsync({ ...data, lang });
    window.open(pdfUrl, '_blank');
  };

  useEffect(() => {
    if (!shipToList) return;
    if (!address) return;
    const selected = shipToList?.find((item) => item?.accountNumber === address.accountNumber);
    setSelectedShipTo(selected);
  }, [shipToList, address]);

  if (!data) {
    return null;
  }

  return (
    <SpinnerBox isLoading={isLoading}>
      <div className="flex w-full">
        <Button type="outline" className={clsx(className, 'flex-1')} onClick={onExport} disabled={disabled || !data}>
          {children}
        </Button>
      </div>
    </SpinnerBox>
  );
};
